import {
  of,
} from 'rxjs';

/**
 * Returns the current hour
 */
export const retrieveCurrentHour = () => (currentDate: Date) => of(currentDate.getHours());

/**
 * Returns the current hour (in UTC)
 */
export const retrieveCurrentUTCHour = () => (currentDate: Date) => of(currentDate.getUTCHours());

/**
 * Returns the current minute
 */
export const retrieveCurrentMinute = () => (currentDate: Date) => of(currentDate.getMinutes());

/**
 * Returns the current minute (in UTC)
 */
export const retrieveCurrentUTCMinute = () => (currentDate: Date) => of(currentDate.getUTCMinutes());

/**
 * Returns the current date
 */
export const retrieveCurrentDate = () => (currentDate: Date) => of(currentDate);

/**
 * Returns the current timestamp
 */
export const retrieveCurrentTimestamp = () => (currentDate: Date) => of(currentDate.toString());

/**
 * Returns the current timestamp (in UTC)
 */
export const retrieveCurrentUTCTimestamp = () => (currentDate: Date) => of(currentDate.toUTCString());

/**
 * Returns the current day of the week
 */
export const retrieveCurrentDayOfTheWeek = () => (currentDate: Date) => of(currentDate.getDay());

/**
 * Returns the current day of the week (in UTC)
 */
export const retrieveCurrentUTCDayOfTheWeek = () => (currentDate: Date) => of(currentDate.getUTCDay());
